import React from 'react';
import { NavLink } from 'react-router-dom';
import { TopMenuStyle } from './Style';

import {
  ProfileOutlined,
  CalendarOutlined,
  CheckSquareOutlined,
  CoffeeOutlined,
  SettingOutlined,
  TeamOutlined,
  IdcardOutlined,
  ProjectOutlined,
  ShoppingOutlined,
  TagsOutlined,
  AppstoreOutlined,
  FileTextOutlined,
  CarryOutOutlined,
  FormOutlined,
  MailOutlined,
  GiftOutlined
} from '@ant-design/icons';

function TopMenu() {
  const path = '/admin';

  const iconStyle = { marginRight: -5, fontSize: 16 };

  return (
    <TopMenuStyle>
      <div className="ninjadash-top-menu">
        <ul>
          <li>
            <NavLink to={`${path}/task-manager`}>
              <ProfileOutlined style={iconStyle} />Tasks
            </NavLink>
          </li>

          <li>
            <NavLink to={`${path}/employeeDailywork`}>
              <FormOutlined style={iconStyle} />Daily Updates
            </NavLink>
          </li>

          <li>
            <NavLink to={`${path}/todo`}>
              <CheckSquareOutlined style={iconStyle} />To Do
            </NavLink>
          </li>

          <li>
            <NavLink to={`${path}/leavecalender`}>
              <CalendarOutlined style={iconStyle} />Calendar
            </NavLink>
          </li>

          <li>
            <NavLink to={`${path}/leaverequestmanage`}>
              <MailOutlined style={iconStyle} />Leave Requests
            </NavLink>
          </li>

          <li className="has-subMenu">
            <NavLink to="#">
              <SettingOutlined style={iconStyle} />Manage
            </NavLink>

            <ul className="subMenu">
              <li>
                <NavLink to={`${path}/teamgroup`}>
                  <TeamOutlined style={iconStyle} />Team Group
                </NavLink>
              </li>
              <li>
                <NavLink to={`${path}/employees`}>
                  <TeamOutlined style={iconStyle} />Employees
                </NavLink>
              </li>

              <li>
                <NavLink to={`${path}/designations`}>
                  <IdcardOutlined style={iconStyle} />Designations
                </NavLink>
              </li>

              <li>
                <NavLink to={`${path}/compose-mail`}>
                  <GiftOutlined style={iconStyle} />Leave
                </NavLink>
              </li>

              <li>
                <NavLink to={`${path}/projects`}>
                  <ProjectOutlined style={iconStyle} />Projects
                </NavLink>
              </li>

              <li>
                <NavLink to={`${path}/Product`}>
                  <AppstoreOutlined style={iconStyle} />Products
                </NavLink>
              </li>

              <li>
                <NavLink to={`${path}/requirements`}>
                  <FileTextOutlined style={iconStyle} />Requirements
                </NavLink>
              </li>

              <li>
                <NavLink to={`${path}/addleave`}>
                  <GiftOutlined style={iconStyle} />Add/Manage Leaves
                </NavLink>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </TopMenuStyle>
  );
}

export default TopMenu;
